export default "__VITE_ASSET__DH4do04m__"